import { memo } from "react"
import styles from "./ViewImage.module.scss"

type ViewImageProps = {
    modalContent?: JSX.Element
    isShown: boolean
    width?: any
    padding?: any
    handleClose?: (value?: any) => void
    height?: string
    source: string
    headerText?: string
    showCloseIcon?: boolean
}

const ViewImage: React.FC<ViewImageProps> = props => {
    const { isShown = true, modalContent, handleClose, headerText, showCloseIcon = true } = props

    if (!isShown) return null

    return (
        <>
            <div className={styles.backdrop} onClick={handleClose}></div>
            <div
                className={styles.popup_container}
                style={{ width: props.width, padding: props.padding, maxHeight: props.height }}>
                <div className={styles.popup_header}>
                    <div className={styles.headerText}>{headerText || "SITE IMAGE"}</div>
                    {showCloseIcon && (
                        <button className={styles.closeButton} onClick={handleClose} aria-label="Close modal">
                            ×
                        </button>
                    )}
                </div>

                <div className={styles.popup_container__inr}>
                    <div className={styles.popup_container__inr__description}>
                        <img src={props.source} alt={headerText || "Preview image"} />
                        {modalContent ? modalContent : null}
                    </div>
                </div>
            </div>
        </>
    )
}
const CustomViewImageModal = memo(ViewImage)
export default CustomViewImageModal
